import React from 'react';
import { noop } from 'lodash';
import cn from 'classnames';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import Variation from '../../base/Variation';
import { ORDER_VARIATION_CARD } from '../../../propTypes';
import Spinner from '../../Spinner';
import Watermark from '../../Watermark';
import { DEFAULT_PACKAGE_TYPE } from './constants';
import './index.scss';

const OrderVariationCard = ({
    orderId,
    onDuplicate = noop,
    onDownload = noop,
    isDuplicateDisabled,
    downloadLink,
    purchaseDate,
    packageType = DEFAULT_PACKAGE_TYPE,
    variation,
    isSellerProjectDeleted = false,
    deliveryPreviewUrl,
    backgroundColor,
    orderLink,
    clickable = false
}) => {
    const onVariationClick = clickable && (() => window.location = orderLink);

    return (
        <div className={cn('order-variation-card-wrapper', { 'in-progress': isDuplicateDisabled, clickable })}>
            <div className="order-variation-card">
                {isSellerProjectDeleted ? (

                    // As we can't have a square variation preview for order with deleted seller's project
                    // we have to display rectangular image as background
                    <div className="delivery-preview-wrapper" style={{ backgroundColor, backgroundImage: `url(${deliveryPreviewUrl})` }}>
                        <Watermark/>
                    </div>
                ) : (
                    <Variation {...variation} withWatermark={true} onClick={onVariationClick}/>
                )}
                {!clickable && <div className="card-overlay">
                    <div className="card-overlay-content">
                        {!isSellerProjectDeleted && <Button onClick={() => onDuplicate(orderId)}
                            disabled={isDuplicateDisabled}
                            className="btn-wide duplicate-order"
                            color="blue">
                            {isDuplicateDisabled ? <Spinner/> : <I18n k="variations_display.cards.order.create"/>}
                        </Button>}
                        <Button href={downloadLink}
                            className="btn-wide"
                            color="blue"
                            fill="ghost"
                            onClick={() => onDownload(orderId)}>
                            <I18n k="variations_display.cards.order.download"/>
                        </Button>
                    </div>
                </div>}
            </div>
            <div className="order-card-footer">
                <p className="order-title">
                    <I18n k={`variations_display.cards.order.${packageType}`}/>{' '}
                    <I18n k="variations_display.cards.order.package"/>
                </p>
                <p>
                    <I18n k="variations_display.cards.order.purchased_on"/>{' '}
                    {purchaseDate}
                </p>
            </div>
        </div>
    );
};

OrderVariationCard.propTypes = ORDER_VARIATION_CARD;

export default OrderVariationCard;
